module.exports = __webpack_public_path__ + "img/home1.95dc9ad0.gif";